import React from "react";

import { assetImg } from "@/modules/moduleImporter";
import { renderResultHistory } from "@/modules/commonPopupResultHistory";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";

//SamGong
export default class M32 extends React.PureComponent<IPopupResultHistoryProps> {
	render() {
		// Template consts
		const { langdata, orientation } = this.props;

		const basePcode = getBasePcode(this.props.activeGame.pcode);

		// angka : Player
		// angka1: banker

		// player_ or banker_
		// 		3p	3 pictures
		// 		anyp  any pictures
		// 		bs: big Small
		// 		oe: odd-even

		// result or win: banker | player



		// PORTRAIT TAB NAMES
		const tabNames = ["Big/Small Odd/Even", "3 Pictures/Any Pictures"];

		// HEADERS
		const landscapeHeaders = [
			langdata["txt_periode"],

			"Player",
			"Banker",
		
			langdata["txt_result"],
		
			"Player",
			"Banker",
		
			"Player",
			"Banker",

			"Player",
			"Banker",

			"Player",
			"Banker"
		];

		// TAB HEADER ELEMENTS
		const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1, 2, 3, 8, 9, 10, 11] :
			this.props.portraitTabIndex === 1 ? [0, 1, 2, 4, 5, 6, 7] : null
		);

		// PROCESS HISTORY HERE
		const bodyMapFunction = (item: any, idx: number) => {
			// PROCESS CONTENTS HERE
			//Add to note:
			// Use <div className="reset-width"> to contain many circle divs

			const cells = [
				item.periode,

				item.angka.split(",").map((_item: string, _idx: number) =>
					assetImg("m32", _item, "m32_prh_player_" + idx + "_" + _idx)
				), //1
				item.angka1.split(",").map((_item: string, _idx: number) =>
					assetImg("m32", _item, "m32_prh_banker_" + idx + "_" + _idx)
				),

				item.result === "banker" ?
					<div className="bg-red">B</div> :
				item.result === "player" ?
					<div className="bg-blue">P</div> :
					<div className="bg-green">T</div>, //3

				//3 Pictures
				item.player_3p ? <div key="p3P" className="bg-blue small-font">3 Pic</div> : "-",
				item.banker_3p ? <div key="b3P" className="bg-red small-font">3 Pic</div> : "-",

				//Any Pictures
				item.player_anyp ? <div key="pAP" className="bg-blue small-font">Any P</div> : "-",
				item.banker_anyp ? <div key="bAP" className="bg-red small-font">Any P</div> : "-",
		
				//Big/Small
				<div key="pBS" className="bg-blue small-font">{item.player_bs}</div>,
				<div key="bBS" className="bg-red small-font">{item.banker_bs}</div>,

				//Odd/Even
				<div key="pOE" className="bg-blue small-font">{item.player_oe}</div>,
				<div key="bOE" className="bg-red small-font">{item.banker_oe}</div>
				
			];



			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);

			return (
				<tr key={"tpdhm_" + idx}>
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
		};



		// Template Tab Headers, no need to change
		const headers = orientation === "landscape" ?
			landscapeHeaders :
			portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			basePcode,
			headers,
			bodyMapFunction,

			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,

			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,

				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			}
		);
	}
}
